<template>
  <div>
    <b-form-row>
      <b-col>
        <b-form-group label="Numéro civique et nom de rue">
          <b-form-input
              v-model.trim="address.street"
              :state="validateState('street')"
              aria-describedby="input-street-feedback"
              @input="setField('street', $event)"
          />
          <b-form-invalid-feedback id="input-street-feedback">
            Le nom et numéro de rue est nécessaire et doit contenir au moins 5 caractères.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Appartement">
          <b-form-input
              v-model.trim="address.app"
              :state="validateState('app')"
              @input="setField('app', $event)"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Ville">
          <b-form-input
              v-model.trim="address.city"
              :state="validateState('city')"
              aria-describedby="input-city-feedback"
              @input="setField('city', $event)"
          />
          <b-form-invalid-feedback id="input-city-feedback">
            Le nom de la ville est nécessaire et doit contenir au moins 2 caractères.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Code postal">
          <the-mask
              mask="S#S #S#"
              :class="{
                'form-control': true,
                'is-invalid': (!$v.address.postal_code.minLength || !$v.address.postal_code.required) && $v.address.postal_code.$dirty,
                'is-valid': $v.address.postal_code.minLength && $v.address.postal_code.required && $v.address.postal_code.$dirty
              }"
              :masked="true"
              v-model="address.postal_code"
              style="text-transform: uppercase"
              aria-describedby="input-postalcode-feedback"
              @input="setField('postal_code', $event)"
          />
          <b-form-invalid-feedback id="input-postalcode-feedback">
            Le code postal doit être sous cette forme (X0X 0X0 ou X0X0X0).
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Province">
          <b-form-select
              :options="states"
              v-model="address.province"
              @input="setField('province', $event)"
              :state="validateState('province')"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Pays">
          <b-form-select
              :options="countries"
              v-model="address.country"
              @input="setField('country', $event)"
              :state="validateState('country')"
              :disabled="true"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
  const { required, minLength } = require('vuelidate/lib/validators');

  export default {
    name: 'address-form-v2',
    props: {
      address: {
        type: Object,
        optional: false
      }
    },
    data() {
      return {
        states: [
          { value: 'Alberta', text: 'Alberta' },
          { value: 'Colombie-Britannique', text: 'Colombie-Britannique' },
          { value: 'Île-du-Prince-Édouard', text: 'Île-du-Prince-Édouard' },
          { value: 'Manitoba', text: 'Manitoba' },
          { value: 'Nouveau-Brunswick', text: 'Nouveau-Brunswick' },
          { value: 'Nouvelle-Écosse', text: 'Nouvelle-Écosse' },
          { value: 'Saskatchewan', text: 'Saskatchewan' },
          { value: 'Terre-Neuve-et-Labrador', text: 'Terre-Neuve-et-Labrador' },
          { value: 'Nunavut', text: 'Nunavut' },
          { value: 'Territoires du Nord-Ouest', text: 'Territoires du Nord-Ouest' },
          { value: 'Yukon', text: 'Yukon' },
          { value: 'Québec', text: 'Québec' },
          { value: 'Ontario', text: 'Ontario' }
        ],
        countries: [ { value: 'Canada', text: 'Canada' } ]
      };
    },
    validations: {
      address: {
        street: {
          required,
          minLength: minLength(5)
        },
        city: {
          required,
          minLength: minLength(2)
        },
        app: {},
        province: {
          required,
          minLength: minLength(2)
        },
        country: {
          required,
          minLength: minLength(2)
        },
        // eslint-disable-next-line camelcase
        postal_code: {
          required,
          minLength: minLength(7)
        }
      }
    },
    methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v.address[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this.address[field] = street;
        this.$v.address[field].$touch();
      }
    }
  };
</script>

<style scoped></style>
